/*
    创建者：shuxiaokai
    创建时间：2019-12-24 17:36
    模块名称：组件选择
    备注：xxxx
*/
<template>
    <div class="widget-config">
        <!-- 组件过滤 -->
        <el-divider content-position="left">组件过滤</el-divider>
        <div class="filter">
            <el-radio-group v-model="formInfo.scene" size="mini">
                <el-radio-button label="plan">计划相关</el-radio-button>
                <el-radio-button label="sample">抽样相关</el-radio-button>
                <el-radio-button label="detection">检验相关</el-radio-button>
            </el-radio-group>
        </div>
        <!-- 组件选择 -->
        <el-divider content-position="left">组件选择</el-divider>
        <s-collapse title="数据组件" class="mb-5">
            <s-select-widget label="抽检批次数" @mousedown.native.stop="handleClickIcon('sampleBatch', 0, $event)">
                <div slot="preview" class="el-icon-present f-60"></div>
            </s-select-widget>
            <s-select-widget label="被抽检单位数" @mousedown.native.stop="handleClickIcon('sampleEnterprise', 1, $event)">
                <div slot="preview" class="el-icon-present f-60"></div>
            </s-select-widget>
            <s-select-widget label="检验机构数" @mousedown.native.stop="handleClickIcon('检验机构数', 2, $event)">
                <div slot="preview" class="el-icon-present f-60"></div>
            </s-select-widget>
            <s-select-widget label="不合格批次数" @mousedown.native.stop="handleClickIcon('不合格批次数', 3, $event)">
                <div slot="preview" class="el-icon-present f-60"></div>
            </s-select-widget>
        </s-collapse>
        <s-collapse title="图表组件">
            
        </s-collapse>
        <!-- 拖拽图表 -->
        <s-drag-card :is-show.sync="showDragCard" :init-left="clickLeft" :init-top="clickTop" @move="handleMove" @mouseup="handleMouseUp">
            <div v-show="dragType === 'card'" class="w-200px h-200px bg-red"></div>
            <!-- 抽检批次数 -->
            <s-icon-card v-show="dragType === 'sampleBatch'">
                <img slot="head" :src="require('@/assets/imgs/excel.png')" width="100%" height="100%" />
                <div slot="title">抽检批次数</div>
                <div slot="subtitle">????</div>
            </s-icon-card>
            <!-- 被抽检单位数 -->
            <s-icon-card v-show="dragType === 'sampleEnterprise'">
                <img slot="head" :src="require('@/assets/imgs/pdf.png')" width="100%" height="100%" />
                <div slot="title">被抽检单位数</div>
                <div slot="subtitle">????</div>
            </s-icon-card>
        </s-drag-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            //=====================================鼠标点击参数====================================//
            clickLeft: 0, //拖拽点击左侧距离
            clickTop: 0, //拖拽点击顶部距离
            showDragCard: false, //是否展示拖拽卡片
            dragType: "", //拖拽类型
            //=====================================图标数据====================================//
            activeIconIndex: 0,
            //=====================================分类参数====================================//
            formInfo: {
                scene: "plan", //业务场景
            },
            //=========================================================================//
        };
    },
    created() {

    },
    methods: {
        //点击图标
        handleClickIcon(type, index, e) {
            e.stopPropagation();
            e.preventDefault();
            this.activeIconIndex = index;
            this.clickLeft = e.clientX;
            this.clickTop = e.clientY;
            this.showDragCard = true;
            this.dragType = type;
            this.$store.commit("changeDragWidgetType", type);
        },
        //处理拖拽组件移动事件
        handleMove(payload) {
            this.$store.commit("changeDragWidgetBoundingClientRect", {
                ...payload
            });
        },
        //松开鼠标新增一个组件
        handleMouseUp(canDrop) {
            if (this.showDragCard && canDrop) {
                /*eslint-disable indent*/ 
                switch (this.dragType) {
                    case "card":
                        this.addCardWidget();
                        break;
                    case "sampleBatch":
                        this.addSampleBatchWidget();
                        break;
                    case "sampleEnterprise":
                        this.addSampleEnterpriseWidget();
                        break;
                    default:
                        break;
                }
            }
        },
        //=====================================创建组件====================================//
        //新增卡片组件
        addCardWidget() {
            const wrap = this.$store.state.widget.wrapConfig.boundingClientRect;
            const widget = this.$store.state.widget.widgetConf;
            // console.log(widget.boundingClientRect)
            this.$store.commit("addCardWidget", {
                type: widget.type,
                left: widget.boundingClientRect.left, //相对父元素left
                top: widget.boundingClientRect.top, //相对父元素top
                width: widget.boundingClientRect.width, //宽度
                height: widget.boundingClientRect.height, //高度
                clientLeft: widget.boundingClientRect.left - wrap.left, //相对于父元素left
                clientTop: widget.boundingClientRect.top - wrap.top, //相对于父元素top    
            });   
        },
        //新增抽样批次数组件
        addSampleBatchWidget() {
            const wrap = this.$store.state.widget.wrapConfig.boundingClientRect;
            const widget = this.$store.state.widget.widgetConf;
            this.$store.commit("addSampleBatchWidget", {
                type: widget.type,
                left: widget.boundingClientRect.left, //相对父元素left
                top: widget.boundingClientRect.top, //相对父元素top
                width: widget.boundingClientRect.width, //宽度
                height: widget.boundingClientRect.height, //高度
                clientLeft: widget.boundingClientRect.left - wrap.left, //相对于父元素left
                clientTop: widget.boundingClientRect.top - wrap.top, //相对于父元素top    
            });   
        },
        //新增被抽检单位数
        addSampleEnterpriseWidget() {
            const wrap = this.$store.state.widget.wrapConfig.boundingClientRect;
            const widget = this.$store.state.widget.widgetConf;
            this.$store.commit("addSampleEnterpriseWidget", {
                type: widget.type,
                left: widget.boundingClientRect.left, //相对父元素left
                top: widget.boundingClientRect.top, //相对父元素top
                width: widget.boundingClientRect.width, //宽度
                height: widget.boundingClientRect.height, //高度
                clientLeft: widget.boundingClientRect.left - wrap.left, //相对于父元素left
                clientTop: widget.boundingClientRect.top - wrap.top, //相对于父元素top    
            }); 
        },
    }
};
</script>



<style lang="scss">
    .widget-config {
        .charts-wrap {
            flex-wrap: wrap;
        }
        .charts-icon {
            flex: 0 0 size(28);
            margin: size(5);
            padding: size(5);
            cursor: grab;
            &:hover {
                background: $gray-200;
            }
            &.active {
                background: $gray-400;
            }
        }
        .icon {
            width: size(28); 
            height: size(28);
            fill: currentColor;
            overflow: hidden;
        }
        // 抽检批次数组件
        .sampleBatch {
            width: size(100);
            height: size(30);
            background: $white;
        }
    }
</style>
